import { CONSULTATIONS_ROUTE, HOME_ROUTE, PRESCRIPTIONS_ROUTE } from '@/routes/route-paths';
import { ImageContentCard } from '@montugroup/circuit-shared/components/braze/ImageContentCard';
import { useLocation } from 'react-router-dom';
import { BRAZE_CONTENT_CARD } from './enums';

export const BrazeImageCard = () => {
  const location = useLocation();

  switch (location.pathname) {
    case CONSULTATIONS_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.PATIENT_CONSULTATIONS} />;
    case HOME_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.PATIENT_HOME} />;
    case PRESCRIPTIONS_ROUTE:
      return <ImageContentCard page={BRAZE_CONTENT_CARD.PATIENT_PRESCRIPTIONS} />;
    default:
      break;
  }
};
